<h6 class="m-0 font-weight-bold">
    {{ 'all' | translate }}: <span class="badge badge-primary">{{ queueState }}</span>
</h6>